export const getPushNotificationNamespace = (namespace: string) => `${namespace}_push_notification`;
